export var raiseError = (error) => {
	return {
		type: "RAISE_ERROR",
		error
	};
};

export var raiseSystemError = (status, message) => {
	return {
		type: "RAISE_ERROR",
		error: message,
		status
	};
};

export var raiseSuccess = (success) => {
	return {
		type: "RAISE_SUCCESS",
		success
	};
};

export var raiseNextSuccess = (success) => {
	return {
		type: "RAISE_NEXT_SUCCESS",
		success
	};
};

export var raiseWarning = (warning) => {
	return {
		type: "RAISE_WARNING",
		warning
	};	
}

export var raiseInfo = (info) => {
	return {
		type: "RAISE_INFO",
		info
	};	
}

export var showNext = () => {
	return {
		type: "SHOW_NEXT"
	};
};

export var clear = () => {
	return {
		type: "RESET_MESSAGES"
	};
};

export var resetErrors = () => {
	return {
		type: "RESET_ERRORS"
	};
};


// WEBPACK FOOTER //
// ./src/actions/messageActions.js